export const START_ITEMS = [
  // {
  //   text: 'Home',
  //   link: 'homepage',
  //   path: '/',
  // },
  {
    text: 'Home',
    link: 'home',
    path: '/',
  },
  {
    text: 'Calendar',
    link: 'calendar',
    path: '/calendar',
  },
  {
    text: 'Locations',
    link: 'locations',
    path: '/locations',
  },
  {
    text: 'Contacts',
    link: 'contacts',
    path: '/contacts',
  },
  {
    text: 'Newsletters',
    link: 'newsletters',
    path: '/newsletters',
  },
  {
    text: 'History',
    link: 'history',
    path: '/history ',
  },
  {
    text: 'Preservation',
    link: 'preservation',
    path: '/preservation',
  },
  {
    text: 'Membership',
    link: 'membership',
    path: '/membership',
  },
  {
    text: 'Publications',
    link: 'publications',
    path: '/publications',
  },
  {
    text: 'Pictures',
    link: 'pictures',
    path: '/pictures',
  },
  {
    text: 'Links',
    link: 'links',
    path: '/links',
  },
  {
    text: 'Officers',
    link: 'officers',
    path: '/officers',
  },
];

export const END_ITEMS = [

];
